import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";
import Config from "./Config";

const firebaseConfig = {
    apiKey: Config.FIREBASE.API_KEY,
    authDomain: Config.FIREBASE.AUTH_DOMAIN,
    projectId: Config.FIREBASE.PROJECTID,
    storageBucket: Config.FIREBASE.STORAGE_BUCKET,
    messagingSenderId: Config.FIREBASE.MESSAGING_SENDERID,
    appId: Config.FIREBASE.APPID,
};

const isConfigured = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId);

export const app = isConfigured ? initializeApp(firebaseConfig) : null;

let messagingInstance = null;
if (app) {
    try {
        messagingInstance = getMessaging(app);
    } catch (error) {
        console.warn("[fcm] messaging unavailable:", error?.message);
    }
}

export const messaging = messagingInstance;
export const messagingSupported = () => (app ? isSupported() : Promise.resolve(false));
